import "./../AboutMe/AboutMe.scss";
import "./Skills.scss";

export function Skills({ skills }: { skills: string[] | string | undefined }) {
  // Ensure skills is always treated as array
  const normalizedSkills = Array.isArray(skills)
    ? skills
    : typeof skills === "string"
    ? skills.split(",").map((s) => s.trim())
    : [];

  return (
    <div className="about-me">
      <h3>Skills</h3>
      <div className="skills">
        {normalizedSkills.map((s, i) => (
          <Chips key={i} title={s} />
        ))}
      </div>
    </div>
  );
}

function Chips({ title }: { title: string }) {
  return <div className="chips">{title}</div>;
}
